import { useState } from 'react'

const DAY_MS = 1000 * 60 * 60 * 24
const DAYS30_MS = DAY_MS * 30

// NOTE: This hook uses null instead of just falling back to undefined.
//  This is because Primereact specifically uses null to describe unset dates.

type DateRangeStateHook = [Date | null, Date | null, (value: Date[]) => void, () => void]

export const useDateRangeState = (startDate?: Date, endDate?: Date): DateRangeStateHook => {
    const [start, setStart] = useState(startDate ?? null)
    const [end, setEnd] = useState(endDate ?? null)

    const setRange = ([nextStart, nextEnd]: Date[]) => {
        setStart(nextStart ?? null)
        setEnd(nextEnd ?? null)
    }

    const resetRange = () => {
        setStart(startDate ?? null)
        setEnd(endDate ?? null)
    }

    return [start, end, setRange, resetRange]
}

export const useDateRangeAgoState = (startDaysAgoMs: number = DAYS30_MS): DateRangeStateHook => {
    const endDate = new Date()
    endDate.setHours(0, 0, 0, 0)
    const startDate = new Date(endDate.getTime() - startDaysAgoMs)
    return useDateRangeState(startDate, endDate)
}
